import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useUserRole } from '../hooks/useUserRole';
import { setAnalyticsIdentity, trackPageView, trackScrollDepth } from './appAnalytics';
import { normalizePagePath } from './appAnalyticsCore';
import { attachScrollDepth, createScrollDepthTracker } from './scrollDepth';

/** Wires Auth role → Analytics. Must sit inside BrowserRouter + AuthProvider. */
export default function AnalyticsGate() {
  const { user } = useAuth();
  const { role, companyId, loading } = useUserRole();
  const loc = useLocation();

  useEffect(() => {
    if (loading) return undefined;
    setAnalyticsIdentity({ uid: user?.uid || null, role, companyId, email: user?.email || null });
    return undefined;
  }, [user?.uid, user?.email, role, companyId, loading]);

  useEffect(() => {
    if (loading) return undefined;
    trackPageView(loc.pathname);
    return undefined;
  }, [loc.pathname, loading, role, user?.uid]);

  // Scroll depth: one tracker for the app lifetime, thresholds reset per route.
  // Same six page keys as page_view; paths outside them (login etc.) send nothing.
  const pathRef = useRef(normalizePagePath(loc.pathname));
  const trackerRef = useRef(null);
  if (!trackerRef.current) {
    trackerRef.current = createScrollDepthTracker((step) => {
      if (pathRef.current) trackScrollDepth(step, pathRef.current);
    });
  }
  useEffect(() => {
    pathRef.current = normalizePagePath(loc.pathname);
    trackerRef.current.reset();
  }, [loc.pathname]);
  useEffect(() => attachScrollDepth(trackerRef.current), []);

  return null;
}
